<template>
  <div class="drag-drop-file-select">
    <div
      class="drag-drop-file-select__dropzone"
      :class="{ 'drag-drop-file-select__dropzone--dragging': dragging }"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      @click="$refs.fileinput.click()"
    >
      <input
        class="drag-drop-file-select__input"
        ref="fileinput"
        type="file"
        :multiple="multiple"
        @change="fileChange"
        :accept="accept"
      />
      <div class="drag-drop-file-select__dropzone-prompt">
        <span v-if="!dragging">
          Drag and drop or click to select files
        </span>
        <span v-else>
          Drop files here
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '*',
    },
  },
  data() {
    return {
      dragging: false,
      files: [],
    };
  },
  methods: {
    fileChange() {
      this.files = [...this.$refs.fileinput.files];
      this.$refs.fileinput.value = null;
      this.$emit('select', this.files);
    },
    dragover(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragging = true;
    },
    dragleave(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragging = false;
    },
    drop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragging = false;
      this.$refs.fileinput.files = e.dataTransfer.files;
      this.fileChange();
    },
  },
};
</script>
<style scoped>
.drag-drop-file-select__dropzone {
  border: 2px dashed #ccc;
  height: 150px;
  /* text-align: center; */
  cursor: pointer;
  transition: border-color 0.3s;
  position: relative;
}
.drag-drop-file-select__dropzone.drag-drop-file-select__dropzone--dragging {
  border-color: #333;
}
.drag-drop-file-select__dropzone-prompt {
  background-color: #f9f9f9;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: -1;
}
.drag-drop-file-select__input {
  opacity: 0;
  position: absolute;
  height: 1px;
  width: 1px;
  z-index: -1;
}
</style>
